var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":_vm.to,"active-class":"active","exact":""}},[(_vm.icon)?_c('span',{staticClass:"align-vertical",class:_vm.icon}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"align-vertical"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }